/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_SpanishInputs */

const en_language_spanish = /** @type {(inputs: Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanish`)
};

const es_language_spanish = /** @type {(inputs: Language_SpanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espanol`)
};

/**
* | output |
* | --- |
* | "Spanish" |
*
* @param {Language_SpanishInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const language_spanish = /** @type {((inputs?: Language_SpanishInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_SpanishInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_spanish(inputs)
	return es_language_spanish(inputs)
});